import React from 'react'
import { SingleSelectComboboxString } from '../../../legacy-design-system/combobox'
import { ServerEnvironment } from '../../servers-grid/shared'
import { allServerEnvironments } from '../../server-environment'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'

export function ServerEnvironmentInput({
  value,
  edited,
  onChange,
  isReadOnly
}: {
  value?: ServerEnvironment
  edited: boolean
  onChange: (value: ServerEnvironment) => void
  isReadOnly?: boolean
}) {
  return (
    <ContrastFormattedMessage id="title_environment_server">
      {(labelEnvironment) => (
        <ContrastFormattedMessage id="title_serverEnvironmentDevelopment">
          {(labelEnvDev) => (
            <ContrastFormattedMessage id="title_serverEnvironmentQualityAssurance">
              {(labelEnvQA) => (
                <ContrastFormattedMessage id="title_serverEnvironmentProduction">
                  {(labelEnvProd) => (
                    <SingleSelectComboboxString<ServerEnvironment>
                      id="serverSettings_environment"
                      label={labelEnvironment}
                      items={[
                        {
                          items: allServerEnvironments
                        }
                      ]}
                      itemToString={(environment) => {
                        switch (environment) {
                          case 'DEVELOPMENT':
                            return labelEnvDev
                          case 'PRODUCTION':
                            return labelEnvProd
                          case 'QA':
                            return labelEnvQA
                        }
                      }}
                      value={value}
                      onChange={onChange}
                      edited={edited}
                      disabled={isReadOnly}
                    />
                  )}
                </ContrastFormattedMessage>
              )}
            </ContrastFormattedMessage>
          )}
        </ContrastFormattedMessage>
      )}
    </ContrastFormattedMessage>
  )
}
